import axiosInstance from "@/shared/api/axiosInstance.js";

export const getPromocodes = () => {
    return axiosInstance.get("/promo-codes");
}